// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import validates from '@/assets/script/validationRule.js' //全局验证
import VirtualCollection from 'vue-virtual-collection'
import Moment from 'moment'
import Echarts from 'echarts'
import 'echarts/map/js/china'

import store from './store/index'

import ElementUI from 'element-ui';

import '@/assets/style/common.css'

import 'element-ui/lib/theme-chalk/index.css'
import 'babel-polyfill'



Vue.use(ElementUI);

// 全局：可搜索(filterable)的 el-select，输入的搜索关键字自动去除前后空格
// 拦截 Element Select 内部的搜索入口 handleQueryChange（本地过滤/自定义 filter-method/远程 remote-method 均经此分发），
// 对入参 trim 后再走原生逻辑，一处覆盖所有可输入下拉框。
// 注意：必须 patch 已注册子类 ElSelect.options.methods（实例的方法即来源于此）；直接改 ElementUI.Select.methods
//   受 webpack 对 element-ui 的 ESM/CJS interop 影响可能取不到目标而静默失败，故从 Vue 注册表取最可靠。
(function () {
  var components = Vue.options.components || {};
  var ElSelect = components.ElSelect || components.elSelect || components['el-select'];
  var methods = ElSelect && ElSelect.options && ElSelect.options.methods;
  var origin = methods && methods.handleQueryChange;
  if (typeof origin === 'function') {
    methods.handleQueryChange = function (val) {
      return origin.call(this, typeof val === 'string' ? val.trim() : val);
    };
  } else {
    console.warn('[el-select trim] 未找到 ElSelect.handleQueryChange，全局去空格未生效');
  }
})();

Vue.use(validates)//验证js

Vue.use(VirtualCollection) //多选框组无限滚动

Vue.config.productionTip = false
// 引入 axios 文件
import api from './axios_api/index.js'
// 绑定 axios 到全局（vue对象原型方法）
Vue.prototype.$api = api
Vue.prototype.echarts = Echarts 
Vue.use(Echarts)

// 图形验证码
import SlideVerify from 'vue-monoplasty-slide-verify';
Vue.use(SlideVerify);

// 引入二次确认弹窗
import confirms from './assets/script/confirm.js'
Vue.prototype.$confirms=confirms
//提示框
import tip from './assets/script/tip.js'
Vue.prototype.$tip=tip

import downloadTips from './assets/script/downloadTips.js'
Vue.prototype.$dTips = downloadTips

// 版本更新检测：发版后在线用户弹窗提示刷新（详见 docs/superpowers/specs/2026-11-02-version-update-check-design.md）
import { startVersionCheck } from '@/assets/script/versionCheck.js'

//全局方法
import common from './assets/script/common.js'
Vue.prototype.$common = common

//获取运营商
import getOpt from './assets/script/base.js'
Vue.prototype.$base = getOpt

//获取卡状态
import stateArr from './assets/script/state.js'
Vue.prototype.$state = stateArr

// 引入 导出下载 文件
import Files from './axios_api/exportFile.js'
// 绑定 导出下载 到全局（vue对象原型方法）
Vue.prototype.$File = Files;


import GetProgressNum from './axios_api/GetProgressNum.js'
Vue.prototype.$GetProgress = GetProgressNum;

Vue.prototype.moment = Moment

//md5加密
import md5 from 'js-md5';
Vue.prototype.$md5 = md5;
//接口路径配置
import globalPath from '@/assets/script/globalPath.vue' 
Vue.prototype.API = globalPath.globalPath //接口路径配置

import VueResource from 'vue-resource' //使用的json数据
Vue.use(VueResource)

import * as filters from '@/assets/script/filters.js'
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

// beforeunload事件在窗口、文档或其资源即将被卸载时触发。你可以在这个事件的处理函数中清除特定的localStorage项。
window.addEventListener('beforeunload', function (event) {
  console.log('beforeunload事件触发了');
  // 清除localStorage中的特定项
  document.cookie = 'CardPageKey = true;path=/;domain=tibiot.com;expires=Thu,01 Jan 1970 00:00:00 GMT';
});
// 页面即将被关闭或切换标签
window.addEventListener('pagehide', function(event) {
  console.log('pagehide即将发生');
  // 清除localStorage中的特定项
  document.cookie = 'CardPageKey = true;path=/;domain=tibiot.com;expires=Thu,01 Jan 1970 00:00:00 GMT';
});


window.Vue = new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
})

// 启动版本更新检测（须在 window.Vue 根实例创建之后调用）
startVersionCheck()



// WEBPACK FOOTER //
// ./src/main.js